/* @ngInject */
const myTrainForm = (
  $$autocomplete,
  $$train,
  toaster
) => {
  return {
    restrict: 'E',
    scope: {
      myTrain: '=',
      enableRequired: '=?',
      enableValidator: '=?',
    },
    template: require('./myTrainForm.html'),

    /* @ngInject */
    controller: (
      $scope
    ) => {
      $scope.myTrain = $scope.myTrain || $$train.new.classic()
      $scope.fieldsOptions = $$train.metadata.fields
      $scope.arrivalRadios = [{
        label: 'Arrivée',
        id: 'arrival',
        value: true,
      }, {
        label: 'Départ',
        id: 'departure',
        value: false,
      }, {
        label: 'Les deux',
        id: 'both',
        value: null,
      },]
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: async (scope, element, attrs, ctrl) => {
        try {
          const tractionnaires = $$autocomplete.request.get('tractionnaire', 'trains')
          const trains = $$autocomplete.request.get('number', 'trains')

          scope.tractionnaires = await tractionnaires
          scope.trains = await trains
        } catch (error) {
          toaster.error(error)
        }
      },
    },
  }
}

export default myTrainForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/train/directives/forms/myTrainForm.js